; (function($, window, document, undefined) {

	var pluginName = "tooltip";

	var defaults = {
		delay: {
			show: 0,
			hide: 0
		},
		arrow: true,
		distance: 11,
		padding: 5,
		placement: "top",
		template: "<div class='tooltip-wrapper'></div>",
		maxWidth: 200,
		zIndex: 1066,
		pauseOnHover: false,
		showEvent: "mouseenter",
		hideEvent: "mouseleave",
		onShow: function() { },
		onHide: function() { },
		onEnter: function() { },
		onLeave: function() { }
	};

	// ----------------------------------------------------------------------------------------------------------------
	// Class definition
	// ----------------------------------------------------------------------------------------------------------------

	function Tooltip(element, options) {
		this.element = element;
		this.$element = $(element);
		this.options = $.extend({}, defaults, options);

		// Handle when "delay" is not an obj
		if (!isNaN(this.options.delay)) {
			var globalDelay = this.options.delay;

			this.options.delay = {
				show: globalDelay,
				hide: globalDelay
			};
		}

		if (this.$element.attr("data-placement")) {
			this.options.placement = this.$element.attr("data-placement");
		}

		this.init();
	}

	Tooltip.prototype = {

		init: function() {
			this.timeoutId = null;

			this.$floater = $(this.options.template).css({
				"position": "absolute",
				"max-width": this.options.maxWidth,
				"z-index": this.options.zIndex
			});

			this.attachEvents();
		},

		attachEvents: function() {
			var self = this;

			// Delay opening when the user hovers over the link
			this.$element
				.on(this.options.showEvent, function(e) {
					window.clearTimeout(self.timeoutId);
					self.options.onEnter(self, e);

					// Delay opening
					self.timeoutId = setTimeout(function() {
						self.show();
					}, self.options.delay.show);
				})
				.on(this.options.hideEvent, function(e) {
					window.clearTimeout(self.timeoutId);
					self.options.onLeave(self, e);

					// Delay closing
					self.timeoutId = setTimeout(function () {
					    if (!self.options.manualClose) {
					        self.hide();
					    }
					}, self.options.delay.hide);
				});
		},

		position: function($el, $to) {
			var toPos = $to.offset();
			var floatHeight = $el.outerHeight();
			var floatWidth = $el.outerWidth();
			var toHeight = $to.outerHeight();
			var toWidth = $to.outerWidth();
			var diffHeight = floatHeight - toHeight;
			var diffWidth = floatWidth - toWidth;

			if (this.options.placement === "top" || this.options.placement === "bottom") {
				if (this.options.placement === "top") {
					toPos.top -= floatHeight + this.options.distance;
				}
				else if (this.options.placement === "bottom") {
					toPos.top += toHeight + this.options.distance;
				}

				// Center horizontally
				toPos.left -= diffWidth / 2;
			}
			else {
				if (this.options.placement === "right") {
					toPos.left += toWidth + this.options.distance;
				}
				else if (this.options.placement === "left") {
					toPos.left -= floatWidth + this.options.distance;
				}

				// Center vertically
				toPos.top -= diffHeight / 2;
			}

			// Adjust for scroll
			//toPos.top -= $(window).scrollTop();

			// Look at viewport
			if (toPos.top < 0) {
				toPos.top = 0;
			}

			$el.css({
				top: toPos.top,
				left: toPos.left
			});
		},

		makeArrow: function() {
			var placeKeys = {
				"top": "arrow_bottom",
				"bottom": "arrow_top",
				"left": "arrow_right",
				"right": "arrow_left"
			};
			var arrowPlacement = placeKeys[this.options.placement];

			return $("<span class='arrow_box'/>").addClass(arrowPlacement);
		},

		show: function() {
			var self = this;
			var $content = $("<div />").append(this.$element.attr("data-title"));

			if ($content.attr("tooltip-padding") !== undefined) {
				this.options.padding = $content.attr("tooltip-padding");
			}

			$content.css({ "padding": this.options.padding });
			$content.addClass("tooltip");
			this.$floater.html($content);
			this.$floater.appendTo(document.body);
			this.options.arrow && this.$floater.append(this.makeArrow());
			this.position(this.$floater, this.$element);

			if (this.options.pauseOnHover) {
				// Add the events again since they were removed on "remove()"
				this.$floater
					// Stop the tooltip from disappearing when hovered
					.on("mouseenter", function() {
						window.clearTimeout(self.timeoutId);
					})
					// Restart the countdown if the user stops hovering
					.on("mouseleave", function() {
						window.clearTimeout(self.timeoutId);

						self.timeoutId = setTimeout(function() {
							self.hide();
						}, self.options.delay.hide);
					});
			}

			this.options.onShow();
		},

		hide: function () {
			this.$floater.empty().remove();
			this.options.onHide();
		}

	};

	// ----------------------------------------------------------------------------------------------------------------
	// Plugin api
	// ----------------------------------------------------------------------------------------------------------------

	$.fn[pluginName] = function(options) {
		if (options === "el") {
			var instance = this.data("plugin_" + pluginName);

			if (instance) {
				return instance.$floater;
			}
		}
		else {
			return this.each(function() {
				if (!$.data(this, "plugin_" + pluginName)) {
					$.data(this, "plugin_" + pluginName, new Tooltip(this, options));
				}
			});
		}
	};

})(jQuery, window, document);